import { useEffect } from 'react';
import { playBeep } from '../../../utils/audio';

export const useOrderPrintManager = ({
  selectedOrder,
  printType,
  eanValidated,
  isPrinting,
  printerModalOpen,
  autoPrintEnabled,
  bridgeConnected,
  selectedPrinter,
  handlePrintLabel,
  handlePrintLabelWithPrinterCheck,
  selectNextOrder,
}) => {

  useEffect(() => {
    if (
      selectedOrder &&
      selectedOrder.status !== "printed" &&
      selectedOrder.channel === "SHOPEE" &&
      printType === "detalhada" &&
      eanValidated.length > 0 &&
      eanValidated.every(Boolean) &&
      !isPrinting &&
      !printerModalOpen
    ) {
      handlePrintLabelWithPrinterCheck(handlePrintLabel);
      setTimeout(() => {
        selectNextOrder();
      }, 300);
    }
  }, [eanValidated, selectedOrder, printType, isPrinting, printerModalOpen]);

  useEffect(() => {
    if (
      autoPrintEnabled &&
      selectedOrder &&
      selectedOrder.status !== "printed" &&
      !(selectedOrder.channel === "SHOPEE" && printType === "detalhada") &&
      bridgeConnected &&
      selectedPrinter &&
      !isPrinting &&
      !printerModalOpen
    ) {
      handlePrintLabel();
    }
  }, [
    selectedOrder,
    autoPrintEnabled,
    printType,
    bridgeConnected,
    selectedPrinter,
    isPrinting,
    printerModalOpen,
  ]);

  return {};
};